import { render, staticRenderFns } from "./2-member-profile-extras.vue?vue&type=template&id=1701f34f&scoped=true"
import script from "./2-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./2-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./2-member-profile-extras.vue?vue&type=style&index=0&id=1701f34f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701f34f",
  null
  
)

export default component.exports